export default __webpack_public_path__ + "static/painting-d1f2b6c50e7cb0d65326a157eb79678e.jpg";